module.exports = __webpack_public_path__ + "static/img/kehuguanli.b7af8b37.png";